<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-exhibition`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 4a1 1 0 011 1v2a1 1 0 01-1 1h-1v22a2 2 0 01-2 2H26v2.868l8.172 4.902a1 1 0 01.343 1.372l-1.03 1.715a1 1 0 01-1.371.343L26 39.532V43a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3.468l-6.114 3.669a1 1 0 01-1.371-.343l-1.03-1.715a1 1 0 01.344-1.373L22 34.868V32H8a2 2 0 01-2-2V8H5a1 1 0 01-1-1V5a1 1 0 011-1h38zm-5 4H10v20h28V8zm-19 8a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6a1 1 0 011-1h2zm6-4a1 1 0 011 1v10a1 1 0 01-1 1h-2a1 1 0 01-1-1V13a1 1 0 011-1h2zm6 6a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1v-4a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconExhibition',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
